export enum TransactionType {
  Credit = 'credit',
  Debit = 'debit',
}

export enum TransactionStatus {
  Pending = 'pending',
  Completed = 'completed',
  Failed = 'failed',
  Reversed = 'reversed',
  Canceled = 'canceled',
  Expired = 'expired',
  Abandoned = 'abandoned',
}

export enum TransactionCategory {
  Regular = 'regular',
  Earnings = 'earnings',
  Fee = 'fee',
  Payout = 'payout',
  Refund = 'refund',
  Sale = 'sale',
  Topup = 'topup',
  Withdrawal = 'withdrawal',
  P2P = 'p2p',
}

export const formTransactionStatuses = [
  TransactionStatus.Pending,
  TransactionStatus.Completed,
  TransactionStatus.Failed,
  TransactionStatus.Reversed,
];

export const formTransactionCategories = [
  TransactionCategory.Regular,
  TransactionCategory.Earnings,
  TransactionCategory.Fee,
  TransactionCategory.Payout,
  TransactionCategory.P2P,
];

const transactionCategoryLabels: Record<string, string> = {
  [TransactionCategory.Regular]: 'Regular',
  [TransactionCategory.Earnings]: 'Earnings',
  [TransactionCategory.Fee]: 'Fee',
  [TransactionCategory.Payout]: 'Payout',
  [TransactionCategory.Refund]: 'Refund',
  [TransactionCategory.Sale]: 'Sale',
  [TransactionCategory.Topup]: 'Top-up',
  [TransactionCategory.Withdrawal]: 'Withdrawal',
  [TransactionCategory.P2P]: 'P2P',
};

const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

export const formatTransactionCategory = (category: string) => {
  if (!category) return '—';
  const normalized = category.toLowerCase();
  return transactionCategoryLabels[normalized] ?? capitalize(normalized);
};

export const formatTransactionStatus = (status: string) => (status ? capitalize(status.toLowerCase()) : '—');

export const formatTransactionType = (type: string) => (type ? capitalize(type.toLowerCase()) : '—');
